/* Uncomment next line to activate HttpClient debugging (logs) */
import {
  HttpClientModule
  /* HTTP_INTERCEPTORS */
} from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { AngularFireModule } from '@angular/fire/compat';
import {
  AngularFireAuthModule
  /* PERSISTENCE */
} from '@angular/fire/compat/auth';
import { AngularFireDatabaseModule } from '@angular/fire/compat/database';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { AngularFireFunctionsModule } from '@angular/fire/compat/functions';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { BsModalService, ModalModule } from 'ngx-bootstrap/modal';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { ToastrModule } from 'ngx-toastr';

import { environment, firebaseApiKey } from '../environments/environment';

import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';

import { RollbarErrorHandler, rollbarFactory, RollbarService } from './shared/services/rollbar/rollbar.service';

import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { ToastComponent } from './shared/components/toast/toast.component';
import { ClickStopPropagationDirective } from './shared/services/protocol-droid/directives/click-stop-propagation.directive';
import { ClickPreventDefaultDirective } from './shared/services/protocol-droid/directives/clicl-prevent-default.directive';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AngularFireModule.initializeApp({ ...environment.firebase, apiKey: firebaseApiKey }),
    AngularFireDatabaseModule,
    AngularFirestoreModule,
    AngularFireAuthModule,
    AngularFireFunctionsModule,
    ModalModule.forRoot(),
    BsDropdownModule.forRoot(),
    PopoverModule.forRoot(),
    SharedModule,
    AppRoutingModule,
    ToastrModule.forRoot({
      timeOut: 4000,
      progressBar: true,
      closeButton: true,
      toastComponent: ToastComponent
    })
  ],
  declarations: [AppComponent, LoginComponent, PageNotFoundComponent, ClickStopPropagationDirective, ClickPreventDefaultDirective, ToastComponent],
  providers: [
    BsModalService,
    { provide: ErrorHandler, useClass: RollbarErrorHandler },
    { provide: RollbarService, useFactory: rollbarFactory },
    { provide: PERFECT_SCROLLBAR_CONFIG, useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG },
    // { provide: PERSISTENCE, useValue: 'session' },
    Title
  ],
  bootstrap: [AppComponent],
  exports: []
})
export class AppModule {}
